import { ArrowRight, Loader2, Sparkles } from 'lucide-react';

import { firstMeaningfulWord } from '@/lib/shop-name';

/**
 * First-login hero — ported from the Lovable `PreTrialScreen` "ready to launch"
 * view onto its own minimal route. The single "Get started" CTA dismisses the
 * welcome screen; there is no skip (only one path forward).
 */
export function ReadyToLaunchHero({ name, onGetStarted, loading }) {
	const firstName = firstMeaningfulWord(name);
	return (
		<div className="w-full max-w-[680px] text-center">
			<div className="mb-6 inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider text-primary">
				<Sparkles className="h-3.5 w-3.5" /> You're all set
			</div>
			<h1 className="text-4xl font-extrabold leading-[1.05] tracking-tight md:text-5xl">
				You're ready to go live
				{firstName ? (
					<>
						, <span className="text-gradient-unify">{firstName}</span>
					</>
				) : null}
			</h1>
			<p className="mx-auto mt-5 max-w-[520px] text-lg text-muted-foreground">
				Your in-store products are about to come alive across Google, your storefront and more.
			</p>
			<button
				type="button"
				onClick={onGetStarted}
				disabled={loading}
				className="mt-10 inline-flex items-center gap-3 rounded-full bg-gradient-unify px-10 py-5 text-lg font-bold text-primary-foreground shadow-[0_20px_40px_-12px_rgba(79,70,229,0.5)] transition-transform hover:scale-[1.02] active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-70 disabled:hover:scale-100"
			>
				{loading ? (
					<>
						<Loader2 className="h-5 w-5 animate-spin" aria-hidden /> Getting started…
					</>
				) : (
					<>
						Let's go <ArrowRight className="h-5 w-5" aria-hidden />
					</>
				)}
			</button>
		</div>
	);
}
